import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { Sidebar } from './components/Sidebar';
import { DashboardPage } from './pages/DashboardPage';
import { PatientsPage } from './pages/PatientsPage';
import { PatientDetailPage } from './pages/PatientDetailPage';
import { AppointmentsPage } from './pages/AppointmentsPage';
import { EncounterEditorPage } from './pages/EncounterEditorPage';
import { EncountersListPage } from './pages/EncountersListPage';
import { TelehealthPage } from './pages/TelehealthPage';
import { MessagesPage } from './pages/MessagesPage';
import { SettingsPage } from './pages/SettingsPage';
import { AuthProvider, useAuth, LoginPage } from './hooks/useAuth';
import { I18nProvider, useI18n } from './i18n';

function Layout() {
    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
                <Outlet />
            </main>
        </div>
    );
}

function AuthGate() {
    const { isAuthenticated, isLoading, login } = useAuth();

    if (isLoading) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100dvh', background: 'var(--color-bg)' }}>
                <div style={{ textAlign: 'center', color: 'var(--color-text-secondary)' }}>
                    <div style={{ fontSize: 36, marginBottom: 12 }}>🏥</div>
                    <p>Cargando ClinicOS...</p>
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <LoginPage onLogin={login} />;
    }

    return (
        <Routes>
            <Route element={<Layout />}>
                <Route path="/" element={<DashboardPage />} />
                <Route path="/patients" element={<PatientsPage />} />
                <Route path="/patients/:id" element={<PatientDetailPage />} />
                <Route path="/appointments" element={<AppointmentsPage />} />
                <Route path="/encounters/:id" element={<EncounterEditorPage />} />
                <Route path="/encounters" element={<EncountersListPage />} />
                <Route path="/telehealth" element={<TelehealthPage />} />
                <Route path="/messages" element={<MessagesPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="*" element={<NotFoundPage />} />
            </Route>
        </Routes>
    );
}

export function App() {
    return (
        <I18nProvider defaultLocale="es">
            <AuthProvider>
                <BrowserRouter basename="/ehr">
                    <AuthGate />
                </BrowserRouter>
            </AuthProvider>
        </I18nProvider>
    );
}

function NotFoundPage() {
    const { t } = useI18n();
    return (
        <div className="page-content fade-in" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 'calc(100dvh - var(--header-height))' }}>
            <div style={{ textAlign: 'center' }}>
                <h1 className="page-title" style={{ fontSize: 'var(--text-3xl)', marginBottom: 'var(--space-2)' }}>404</h1>
                <p style={{ color: 'var(--color-text-muted)', fontSize: 'var(--text-sm)', marginTop: 'var(--space-4)' }}>
                    Página no encontrada
                </p>
            </div>
        </div>
    );
}

